//#region imports
// core
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// main
import { MyApp } from './app.component';

// config
import { environment } from '../environment/environment';

// Ionic Native Plugins
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { GooglePlus } from '@ionic-native/google-plus';
import { Geolocation } from '@ionic-native/geolocation';

//services
import { DashboardService } from '../pages/dashboard/dashboard.service';
import { ProfileService } from '../pages/profile/profile.service';
import { FirebaseService } from '../pages/firebase-integration/firebase-integration.service';
import { FirebaseAuthService } from '../pages/firebase-integration/firebase-auth.service';
import { LanguageService } from '../services/language/language.service';
import { CompanyService } from '../services/company.service';
import { ProfileStorageService } from '../services/profile-storage.service';
import { LocationServices } from '../services/locationServices';
import { NewsService } from '../pages/news/news.service';
import { JobberService } from '../services/job.service';
import { InvestorService } from '../services/investor.service';

// Providers
import { DataProvider } from '../services/data.service';
import { BillingProvider } from '../services/billing.service';
import { ContactUsProvider } from '../services/contact-us.service';

//Angular Fire
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';

// 3rd party
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CloudinaryModule } from '@cloudinary/angular-5.x';
import { Cloudinary } from 'cloudinary-core';
//#endregion imports

export const cloudinaryLib = {
  Cloudinary: Cloudinary
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CloudinaryModule.forRoot(cloudinaryLib, {
      cloud_name: environment.cloudinary.cloud_name,
      upload_preset: environment.cloudinary.upload_preset
    }),
    IonicModule.forRoot(MyApp, {
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      pageTransition: 'ios-transition',
      swipeBackEnabled: false
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    DashboardService,
    ProfileService,
    LanguageService,
    FirebaseAuthService,
    FirebaseService,
    LocationServices,
    CompanyService,
    ProfileStorageService,
    NewsService,
    InvestorService,
    JobberService,
    SplashScreen,
    StatusBar,
    GooglePlus,
    Geolocation,
    DataProvider,
    BillingProvider,
    ContactUsProvider
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts